import {
  GET_BOARDS_TICKETS_REQUEST,
  GET_BOARDS_TICKETS_FAIL,
  GET_BOARDS_TICKETS_SUCCESS,
  CREATE_TICKET_SUCCESS,
  EDIT_TICKET_SUCCESS,
  DND_TICKET,
  REMOVE_TICKET_SUCCESS,
  GET_TICKET_DETAILS_SUCCESS,
  GET_TICKET_DETAILS_REQUEST,
  GET_TICKET_DETAILS_FAIL,
  GET_MORE_BOARDS_TICKETS_SUCCESS,
  SORT_BOARDS_TICKETS_SUCCESS,
  CREATE_TICKET_REQUEST,
  CREATE_TICKET_FAIL,
  EDIT_TICKET_FAIL,
  EDIT_TICKET_REQUEST,
  UPDATE_TICKET_REQUEST,
  UPDATE_TICKET_FAIL,
  UPDATE_TICKET_SUCCESS,
  GET_BOARDS_FILTER_LOOKUP_SUCCESS,
  GET_USER_MANAGEMENT_SUCCESS,
  CHANGE_CURRENT_BOARD,
  GET_TICKET_AGING_REQUEST,
  GET_TICKET_AGING_SUCCESS,
  GET_TICKET_AGING_FAIL,
  GET_TICKET_SUMMARY_STAGES_REQUEST,
  GET_TICKET_SUMMARY_STAGES_SUCCESS,
  GET_TICKET_SUMMARY_STAGES_FAIL,
  GET_TICKET_SUMMARY_AGING_REQUEST,
  GET_TICKET_SUMMARY_AGING_SUCCESS,
  GET_TICKET_SUMMARY_AGING_FAIL,
  EXPORT_TICKETS_LIST_REQUEST,
  EXPORT_TICKETS_LOG_REQUEST,
  EXPORT_TICKETS_LIST_SUCCESS,
  EXPORT_TICKETS_LOG_SUCCESS, EXPORT_TICKETS_LIST_FAIL, EXPORT_TICKETS_LOG_FAIL, EDIT_TICKET_REMARKS_SUCCESS
} from "../actions/boards";

const initialState = {
  loading: false,
  tickets: {},
  total_tickets: {},
  people_data: [],
  filters: null,
  ticketDetails: {},
  modalsLoading: false,
  userManagement: [],
  currentBoard: 'Tasks',
  ticketAging: {
    loading: true,
    chart: [],
    max: null
  },
  ticketSummaryStages: {
    loading: true,
    chart: []
  },
  ticketSummaryAging: {
    loading: true,
    chart: []
  },
  exportLoading: false
};

export default function boards(state = initialState, action) {
  switch (action.type) {
    case GET_BOARDS_TICKETS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case GET_BOARDS_TICKETS_SUCCESS:
    case REMOVE_TICKET_SUCCESS:
    case DND_TICKET:
      return {
        ...state,
        tickets: action.payload,
        total_tickets: action.total_tickets ? action.total_tickets : state.total_tickets,
        people_data: action.people_data,
        loading: false,
      };

    case CREATE_TICKET_SUCCESS:
    case EDIT_TICKET_SUCCESS:
      return {
        ...state,
        tickets: action.payload,
        modalsLoading: false,
      };

    case GET_BOARDS_TICKETS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_BOARDS_FILTER_LOOKUP_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    case GET_TICKET_DETAILS_REQUEST:
    case CREATE_TICKET_REQUEST:
    case EDIT_TICKET_REQUEST:
    case UPDATE_TICKET_REQUEST:
      return {
        ...state,
        modalsLoading: true
      };
    case GET_TICKET_DETAILS_SUCCESS:
      return {
        ...state,
        ticketDetails: action.payload,
        modalsLoading: false
      };
    case GET_TICKET_DETAILS_FAIL:
    case CREATE_TICKET_FAIL:
    case EDIT_TICKET_FAIL:
    case UPDATE_TICKET_FAIL:
    case UPDATE_TICKET_SUCCESS:
      return {
        ...state,
        modalsLoading: false
      };

    case GET_MORE_BOARDS_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: action.payload,
      };
    case SORT_BOARDS_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: action.payload,
      };
    case GET_USER_MANAGEMENT_SUCCESS:
      return {
        ...state,
        userManagement: action.payload,
      };
    case CHANGE_CURRENT_BOARD:
      return {
        ...state,
        currentBoard: action.payload,
      };

    case GET_TICKET_AGING_REQUEST:
      return {
        ...state,
        ticketAging: {
          ...state.ticketAging,
          loading: true
        },
      };
    case GET_TICKET_AGING_SUCCESS:
      return {
        ...state,
        ticketAging: {
          loading: false,
          ...action.payload
        },
      };
    case GET_TICKET_AGING_FAIL:
      return {
        ...state,
        ticketAging: {
          ...state.ticketAging,
          loading: false,
        },
      };

    case GET_TICKET_SUMMARY_STAGES_REQUEST:
      return {
        ...state,
        ticketSummaryStages: {
          ...state.ticketSummaryStages,
          loading: true
        },
      };
    case GET_TICKET_SUMMARY_STAGES_SUCCESS:
      return {
        ...state,
        ticketSummaryStages: {
          loading: false,
          ...action.payload
        },
      };
    case GET_TICKET_SUMMARY_STAGES_FAIL:
      return {
        ...state,
        ticketSummaryStages: {
          ...state.ticketSummaryStages,
          loading: false,
        },
      };

      case GET_TICKET_SUMMARY_AGING_REQUEST:
      return {
        ...state,
        ticketSummaryAging: {
          ...state.ticketSummaryAging,
          loading: true
        },
      };
    case GET_TICKET_SUMMARY_AGING_SUCCESS:
      return {
        ...state,
        ticketSummaryAging: {
          loading: false,
          ...action.payload
        },
      };
    case GET_TICKET_SUMMARY_AGING_FAIL:
      return {
        ...state,
        ticketSummaryAging: {
          ...state.ticketSummaryAging,
          loading: false,
        },
      };
    case EXPORT_TICKETS_LIST_REQUEST:
    case EXPORT_TICKETS_LOG_REQUEST:
      return {
        ...state,
        exportLoading: true
      };

    case EXPORT_TICKETS_LIST_SUCCESS:
    case EXPORT_TICKETS_LOG_SUCCESS:
    case EXPORT_TICKETS_LIST_FAIL:
    case EXPORT_TICKETS_LOG_FAIL:
      return {
        ...state,
        exportLoading: false
      };

    case EDIT_TICKET_REMARKS_SUCCESS:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          Remarks: action.payload
        }
      }


    default:
      return state;
  }
}
